module.exports = __webpack_public_path__ + "static/media/desktop-onboarding-2.175672d7.svg";